import { useMemo } from "react";
import landingContentJson from "./landingContent.json";
import landingStylesJson from "./landingStyles.json";
import { useRouter } from "next/router";
import { showIntercomNewMessage } from "../../pixelmixer-webapp/src/util/Utils";
import Link from "next/link";

const LandingPageContent = ({}) => {
  const router = useRouter();
  const { topic } = router.query;

  const { landingContent } = landingContentJson;
  const { videoIFrameStyle, copyStyle } = landingStylesJson;
  const content = useMemo(() => landingContent[topic]);
  return content ? (
    <div className="col-lg-7">
      <div className="row justify-content-center signup-3-header">
        <div className="col-lg-10 col-xl-8">
          <div className="section-title">
            <div className="tags justify-content-center d-flex">
              <span> {content.tag}</span>
            </div>
            <div className="space16"></div>
            <h2 style={{ textAlign: "center" }}>{content.title}</h2>
            <div className="space16"></div>
          </div>
        </div>
      </div>
      <div className="signup-3-img text-center">
        <iframe
          style={videoIFrameStyle}
          src={content.videoUrl}
          scrolling="no"
          allowFullScreen={true}
        />
        <div className="space32"></div>
        <Link
          href="#"
          onClick={() => showIntercomNewMessage("I would like a demo.")}
          className="header-btn"
        >
          Request a Demo<i className="fa-solid fa-headset"></i>
        </Link>
        <div className="space32"></div>
      </div>
      <div className="row justify-content-center signup-3-header">
        <div>
          <div className="section-title">
            <h4>{content.caption}</h4>
            <div className="space16"></div>
          </div>
          <p style={copyStyle}>{content.copy}</p>
        </div>
      </div>
      <div className="space32"></div>
      <div className="blog-inner-section">
        <div className="blog-inner-content">
          <div className="blog-inner-boxs">
            <div className="row align-items-center">
              <div className="col-lg-4">
                <a href={content.blogUrl}>
                  <div className="images">
                    <img src={content.blogThmbnail} alt="" />
                  </div>
                </a>
              </div>
              <div className="col-lg-8">
                <div className="content tags">
                  <span>Learn More</span>
                  <div className="space16"></div>
                  <a href={content.blogUrl}>{content.blogLinkText}</a>
                  <div className="space16"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="space16"></div>
    </div>
  ) : (
    <></>
  );
};

export default LandingPageContent;
